import './product_list_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'products',
    'loadMoreButton'
  ]

  loadNextPage (event) {
    event.preventDefault()
    const that = this
    window.fetch(this.nextPageUrl).then(response => response.json()).then((data) => {
      that.productsTarget.insertAdjacentHTML('beforeend', data.products)
      that.nextPageUrl = data.next_page
      that.updateLoadMoreButtonDisplay()
    })
  }

  updateLoadMoreButtonDisplay () {
    if (this.nextPageUrl === '') {
      this.loadMoreButtonTarget.style.display = 'none'
    } else {
      this.loadMoreButtonTarget.style.display = 'inline-block'
    }
  }

  get nextPageUrl () {
    return this.data.get('nextPageUrl')
  }

  set nextPageUrl (url) {
    this.data.set('nextPageUrl', url)
  }
}
